/*
 * Animation Constants.
 */

// We just jumped to an annotation, so the annotation turns blue.
// 2400ms + 600ms == 3s
export const ANNOTATION_JUMP_ANIMATION_DELAY_MS = 2400;
export const ANNOTATION_JUMP_ANIMATION_DURATION_MS = 600;

// We just jumped to a comment, so the comment background turns blue.
export const COMMENT_JUMP_ANIMATION_DURATION_MS = 3000;

// We just pinned a comment, so the comment background turns blue.
export const PINNED_COMMENT_ANIMATION_DURATION_MS = 3000;
